/* eslint-disable max-lines */
import { act } from 'api';
import {
  SET_ACT_PROPERTY,
  ACT_GET_ACT,
  SIGN_INIT_GUID,
  ACT_ERROR,
  ACT_CMS,
  ACT_SAVE_DATA,
  ACT_CONFIRM_IDENTITY,
  SEND_SIGN,
  END_SIGN,
  CANCEL_ACT,
  VALIDATE_DOCUMENT,
  GET_DOCUMENTS,
  ACT_GET_CONCESSIONS,
  GET_REQUIDED_DOCUMENTATION
} from 'store/actions/act';
import { UI_UPDATE_FROM_PARTNER } from 'store/actions/ui';
import { lsRemoveAct, lsSetAct } from 'helpers/store';

import { dateToString } from 'helpers/date';
import { GENERIC_DRIVER_ID, GENERIC_DRIVER_DATA } from 'store/enums';

export default {
  [SET_ACT_PROPERTY]: ({ commit }, { field, value }) => commit(SET_ACT_PROPERTY, { field, value }),

  [ACT_CONFIRM_IDENTITY]: ({ commit }, { identity }) =>
    new Promise((resolve, reject) => {
      act
        .loginWithGuid(identity)
        .then(
          () => {
            commit(SET_ACT_PROPERTY, {
              field: 'errorIdentity',
              value: null
            });
            resolve();
          },
          err => {
            commit(SET_ACT_PROPERTY, {
              field: 'errorIdentity',
              value: err.response.data.message || null
            });
            reject();
          }
        )
        .catch();
    }),

  [ACT_GET_CONCESSIONS]: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      const { documentId, zipCode } = getters.data('identity');
      act.getConcessions(documentId, zipCode).then(
        resp => {
          const concessionData = resp.data;
          commit(SET_ACT_PROPERTY, {
            field: 'concessions',
            value: concessionData
          });
          commit(SET_ACT_PROPERTY, {
            field: 'errorGetConcessions',
            value: null
          });
          resolve();
        },
        err => {
          commit(SET_ACT_PROPERTY, {
            field: 'errorGetConcessions',
            value: err.response.data.message || null
          });
          reject();
        }
      );
    }),

  /* eslint-disable complexity */
  [ACT_GET_ACT]: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      lsRemoveAct();
      act.login(getters.data('identity')).then(
        resp => {
          const actData = resp.data;
          actData.vehicle.currentKilometers = actData.vehicle.currentKilometers.toString();
          actData.driver.expeditionDateDrivingLicense = actData.driver.expeditionDateDrivingLicense
            ? dateToString(actData.driver.expeditionDateDrivingLicense)
            : '';
          if (
            actData.driver.contactInfo &&
            actData.driver.contactInfo.mobile &&
            actData.driver.contactInfo.mobile.charAt(0) === '9'
          ) {
            actData.driver.contactInfo.mobile = '';
          }

          if (actData.driver.documents) {
            actData.driver.documentsUploaded = actData.driver.documents.reduce(
              (h, { documentType, documentURL }) =>
                Object.assign(h, {
                  [documentType]: (h[documentType] || []).concat({
                    documentURL
                  })
                }),
              {}
            );
          }

          if (actData.driver.driverId === GENERIC_DRIVER_ID) {
            actData.driver = GENERIC_DRIVER_DATA;
          }

          lsSetAct(actData);
          commit(SET_ACT_PROPERTY, {
            field: 'act',
            value: actData
          });
          commit(SET_ACT_PROPERTY, {
            field: 'errorIdentity',
            value: null
          });
          resolve();
        },
        err => {
          commit(SET_ACT_PROPERTY, {
            field: 'errorIdentity',
            value: err.response.data.message || null
          });
          reject();
        }
      );
    }),
  /* eslint-enable complexity */

  [ACT_CMS]: ({ commit }, { partnerId, patternId }) =>
    new Promise((resolve, reject) => {
      act.cms(partnerId, patternId).then(
        resp => {
          commit(SET_ACT_PROPERTY, {
            field: 'componentsCMS',
            value: [resp.data]
          });
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [GET_REQUIDED_DOCUMENTATION]: ({ commit }, { partnerId, stepId }) =>
    new Promise((resolve, reject) => {
      act.catalogByPartnerIdAndStep(partnerId, stepId).then(
        resp => {
          commit(UI_UPDATE_FROM_PARTNER, { data: resp.data, stepId });
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [ACT_SAVE_DATA]: (params, { transactionId, data }) =>
    new Promise((resolve, reject) => {
      act.saveData(transactionId, data).then(
        () => {
          act.send(transactionId).then(
            () => {
              // lsRemoveAct();
              resolve();
            },
            err => {
              reject(err.response.data);
            }
          );
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [SIGN_INIT_GUID]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      // lsRemoveAct();
      const transactionId = params.transactionId;
      act.getActByGuid(transactionId).then(
        resp => {
          if (resp && resp.isNotValid) {
            console.log('Guid no válido');
          } else {
            const actData = resp.data;
            actData.vehicle.currentKilometers = resp.data.vehicle.currentKilometers.toString(); // eslint-disable-next-line no-param-reassign
            actData.driver.expeditionDateDrivingLicense = resp.data.driver
              .expeditionDateDrivingLicense
              ? dateToString(resp.data.driver.expeditionDateDrivingLicense)
              : '';
            lsSetAct(actData);
            commit(SET_ACT_PROPERTY, {
              field: 'act',
              value: actData
            });
            resolve(actData.partnerId);
          }
        },
        err => {
          commit(ACT_ERROR, err);
          reject();
        }
      );
    }),

  [SEND_SIGN]: (params, { transactionId, partnerId }) =>
    new Promise((resolve, reject) => {
      act.sendSign(transactionId, partnerId).then(
        resp => {
          resolve(resp.data);
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [CANCEL_ACT]: (params, { transactionId, comment }) =>
    new Promise((resolve, reject) => {
      act.cancelAct(transactionId, comment).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [VALIDATE_DOCUMENT]: (params, data) =>
    new Promise((resolve, reject) => {
      act.validateDocument(data).then(
        () => {
          resolve();
        },
        err => {
          reject(err.response.data);
        }
      );
    }),

  [END_SIGN]: ({ commit }, { transactionId }) =>
    new Promise((resolve, reject) => {
      act.endSign(transactionId).then(
        () => {
          /* act.sendEmail(transactionId).then(
            () => {
              resolve();
            },
            err => {
              commit(ACT_ERROR, err);
              reject();
            }
          ); */
          resolve();
        },
        err => {
          commit(ACT_ERROR, err);
          reject();
        }
      );
    }),

  [GET_DOCUMENTS]: (params, data) =>
    new Promise((resolve, reject) => {
      act.getDocuments(data).then(
        resp => {
          resolve(resp.data);
        },
        err => {
          reject(err.response.data);
        }
      );
    })
};
